export default {
  SET_BUTTON_STATE: 'SET_BUTTON_STATE',
};



// WEBPACK FOOTER //
// ./src/features/Button/constants.js